// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.argyle-data,
.identity-data {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  background: white;
  border-bottom: 1px solid #d8d9ea;
  padding-top: 20px;
}
.argyle-data table,
.identity-data table {
  width: 99%;
}
.argyle-data table th,
.identity-data table th,
.argyle-data table td,
.identity-data table td {
  text-align: center;
}
.filter-title {
  border-bottom-color: #d8d9ea;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
h3.filter-title {
  background: #e1dbe2;
  margin: 0;
  padding: 15px;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.source-verified {
  background-color: rgba(46, 139, 7, 0.6) !important;
}
.source-not-verified {
  background-color: rgba(184, 9, 9, 0.4) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/income-source-list/income-source-list.component.less"],"names":[],"mappings":"AACA;;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,iBAAA;EACA,gCAAA;EACA,iBAAA;AAAJ;AAPA;;EASQ,UAAA;AAER;AAXA;;;;EAYY,kBAAA;AAKZ;AAAA;EACI,4BAAA;EACA,0BAAA;EACA,wBAAA;AAEJ;AACA;EACI,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAGA;EACI,kDAAA;AADJ;AAGE;EACE,iDAAA;AADJ","sourcesContent":["@import (reference) url('../../../styles.less');\n.argyle-data,.identity-data{\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 1.2;\n    // padding: 0 10px;\n    background: white;\n    border-bottom: 1px solid @h1-bottom;\n    padding-top: 20px;\n    table{\n        width: 99%;     \n        th, td{\n            // border: 1px solid;\n            text-align: center;\n        }\n    }\n}\n\n.filter-title{\n    border-bottom-color:rgb(216, 217, 234);\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\n\nh3.filter-title{\n    background: rgb(225,219,226);\n    margin: 0;\n    padding: 15px;\n    font-size: 16px;\n    font-weight: 400;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n\n.source-verified{\n    background-color: rgba(46,139,7,0.6) !important;\n  }\n  .source-not-verified{\n    background-color: rgba(184,9,9,0.4) !important;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
